import { render, staticRenderFns } from "./Forestales.vue?vue&type=template&id=faddb430"
import script from "./Forestales.vue?vue&type=script&lang=js"
export * from "./Forestales.vue?vue&type=script&lang=js"
import style0 from "./Forestales.vue?vue&type=style&index=0&id=faddb430&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports